import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { UpdateUserRequest } from '../../api/update-user/updateUser.types';
import type {
  UseUpdateUserParams,
  UseUpdateUserResult,
} from './useUpdateUser.types';

import { updateUser } from '../../api/update-user/updateUser';

export function useUpdateUser(
  params: UseUpdateUserParams
): UseUpdateUserResult {
  const queryClient = useQueryClient();

  return useMutation<void, Error, UpdateUserRequest>({
    mutationFn: (data: UpdateUserRequest): Promise<void> =>
      updateUser(params.organizationId, data),
    onSuccess: async (): Promise<void> => {
      await queryClient.invalidateQueries({ queryKey: ['users'] });
    },
  });
}
